import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useAdvancedHotkeysSetting } from '../../../hooks/use-user-setting';
import { saveUserSetting } from '../../../store/user/user.actions';
import { UserSettings } from '../../../enums/user-settings/user-settings';

export const useUserSettingAdvancedHotkeys = () => {
  const dispatch = useDispatch();
  const areAdvancedHotkeysEnabled = useAdvancedHotkeysSetting();

  const updateAdvancedHotkeysUserSetting = useCallback(
    (newSetting) => {
      dispatch(
        saveUserSetting({
          settingName: UserSettings.advancedHotkeys.settingName,
          settingValue: newSetting,
          excludeV3prefix: true,
        }),
      );
    },
    [dispatch],
  );
  const result = useMemo(
    () => ({
      areAdvancedHotkeysEnabled,
      setAreAdvancedHotkeysEnabled: updateAdvancedHotkeysUserSetting,
    }),
    [areAdvancedHotkeysEnabled, updateAdvancedHotkeysUserSetting],
  );
  return result;
};
